import React from "react";
import { useNavigate } from "react-router-dom";

import Check from "../assets/images/check.png";
import { useSelector } from "react-redux";

export default function WelcomePopup() {
  const DD = useSelector((e: any) => e.domainDetails);
  const navigate = useNavigate();
  const onClickNavigate = (path: string) => {
    localStorage.setItem("isSignUpLogin", "false");
    navigate(path);
  };
  return (
    <div className="popup-wrp popup-show fade welcome-popup">
      <div className="pop pop-content">
        <div className="pop-body">
          <img src={Check} alt="Check" width="100" />
          <h3>Welcome</h3>
          <p className="green-text">
            You are now a member of {DD?.title?.split(".")[0]}
          </p>
          <p>
            Step into the world full of adventure with us! Start placing your
            bets and good luck!
          </p>
          <button className="btn deposit" onClick={() => onClickNavigate("/")}>
            Home Page
          </button>
          <button
            className="btn home"
            onClick={() => onClickNavigate("/deposit")}
          >
            Deposit Now
          </button>
        </div>
      </div>
    </div>
  );
}
